import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { UserAuthService } from '../services/user-auth.sevice';
import { UserPermission } from '../store/state/auth-user';
import { featureName, moduleName, operationName } from '../constant/user-role-constant';

export interface Permission {

  // Task Management Permissions
  taskManagementCreate: "taskManagementCreate";
  taskManagementEdit: "taskManagementEdit";
  taskManagementView: "taskManagementView";
  taskManagementDelete: "taskManagementDelete";
  taskManagementAll: "taskManagementAll";

  // Task Special Permissions
  taskSpecialPermissionCreate: "taskSpecialPermissionCreate";
  taskSpecialPermissionEdit: "taskSpecialPermissionEdit";
  taskSpecialPermissionView: "taskSpecialPermissionView";
  taskSpecialPermissionDelete: "taskSpecialPermissionDelete";
  taskSpecialPermissionAll: "taskSpecialPermissionAll";
}

@Directive({
  selector: '[appTaskPermission]'
})
export class TaskPermissionDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userAuthService: UserAuthService
  ) { }

  @Input('appTaskPermission') set appTaskHasPermission(permissionKeys: (keyof Permission)[] | keyof Permission) {

    const permissionsArray = Array.isArray(permissionKeys) ? permissionKeys : [permissionKeys];
    const permissionSets: UserPermission[] = [];

    permissionsArray.forEach(permissionKey => {
      const mappedPermissions = this.mapPermission(permissionKey);
      permissionSets.push(...mappedPermissions);
    });

    const hasPermission = this.userAuthService.hasPermission(permissionSets);
    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private mapPermission(permissionKey: keyof Permission): UserPermission[] {
    const permissionMappings: Record<keyof Permission, UserPermission> = {
      taskManagementCreate: { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.create },
      taskManagementEdit: { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.write },
      taskManagementView: { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.view },
      taskManagementDelete: { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.delete },
      taskManagementAll: { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.all },
      taskSpecialPermissionCreate: { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.create },
      taskSpecialPermissionEdit: { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.write },
      taskSpecialPermissionView: { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.view },
      taskSpecialPermissionDelete: { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.delete },
      taskSpecialPermissionAll: { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.all },
    };

    const permission = permissionMappings[permissionKey];
    return permission ? [permission] : [];
  }

}
